import _ from 'lodash';
import { useRef } from 'react';
import type { RequestEvent, RequestEventEmitter } from './makeRequest';

/**
 * Create a RequestEventEmitter that keeps track of its subscribers.
 *
 * @deprecated - This pattern is outdated -- use useAsyncValue and friends (like useAsyncRequest) instead.
 */
const useRequestEventEmitter = <Context>(): RequestEventEmitter<Context> => {
  // Subscriber functions are stored with useRef because this lets us reliably pass the RequestEventEmitter object
  // around to async functions and because adding and removing subscribers should not cause re-renders.
  const subscribers = useRef<Array<(event: RequestEvent<Context>) => void>>([]);

  const subscribe = (fn: (event: RequestEvent<Context>) => void) => {
    subscribers.current = _.union(subscribers.current, [fn]);
  };

  const unSubscribe = (fn: (event: RequestEvent<Context>) => void) => {
    subscribers.current = _.difference(subscribers.current, [fn]);
  };

  const emit = (event: RequestEvent<Context>) => {
    subscribers.current.forEach(subscriberFn => subscriberFn(event));
  };

  return {
    subscribe,
    unSubscribe,
    emit,
  };
};

export default useRequestEventEmitter;
